import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function SvgIconChildren() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          fill="currentColor"
          stroke="none"
          d="M4 11c0-4.5 4-8 8-8s8 3.5 8 8H4z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 11v3.5a4 4 0 0 0 8 0V11"
        />
      </svg>
    </SvgIcon>
  );
};
